module.exports = __webpack_public_path__ + "static/media/empty_avatar.1bdab980.jpg";